import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import "./datepicker.css";

const DatePickercomp = ({ value, sendDate, ...props }) => {
    const [selectedDate, setSelectedDate] = useState(null);

    // Parse a "YYYY-MM-DD" string (or Date) into a local Date, ignoring UTC shift.
    const toLocalDate = (v) => {
        if (!v) return null;
        if (v instanceof Date) return v;
        const [year, month, day] = String(v).split("-").map(Number);
        if (!year || !month || !day) return null;
        return new Date(year, month - 1, day);
    };

    // Allowed range for this picker.
    // minDate: lower bound (e.g. To-Date can't be before the selected From-Date).
    // maxDate: explicit upper bound (e.g. From-Date can't be after the selected
    // To-Date); falls back to today unless future dates are explicitly allowed.
    const minDate = toLocalDate(props?.minDate);
    const maxFromProps = toLocalDate(props?.maxDate);
    const maxDate = maxFromProps
        ? maxFromProps
        : !props?.allowFutureDates
          ? new Date()
          : null;

    useEffect(() => {
        if (!value) {
            setSelectedDate(null);
            return;
        }
        let d;
        if (value instanceof Date) {
            d = value;
        } else {
            // Parse "YYYY-MM-DD" as a local date to avoid UTC shift.
            const [year, month, day] = String(value).split("-").map(Number);
            d = new Date(year, month - 1, day);
        }
        if (!d || isNaN(d.getTime())) {
            setSelectedDate(null);
            return;
        }
        // Ignore a value that falls OUTSIDE the allowed [minDate, maxDate] range.
        // Otherwise a stale / out-of-range value (e.g. an old year) would open the
        // calendar locked on a fully-disabled month and the user could not re-pick.
        const min = minDate ? new Date(minDate) : null;
        if (min) min.setHours(0, 0, 0, 0);
        const max = maxDate ? new Date(maxDate) : null;
        if (max) max.setHours(23, 59, 59, 999);
        if ((min && d < min) || (max && d > max)) {
            setSelectedDate(null);
            return;
        }
        setSelectedDate(d);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, props?.minDate, props?.maxDate, props?.allowFutureDates]);

    const handleDateChange = (date) => {
        if (!date) return;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formatted = `${year}-${month}-${day}`;
        setSelectedDate(date);
        sendDate(formatted);
    };

    return (
        <DatePicker
            selected={selectedDate ? new Date(selectedDate) : null}
            onChange={handleDateChange}
            // When nothing valid is selected, open the calendar on a usable month
            // (today, which is within range) instead of a disabled one.
            openToDate={selectedDate ? new Date(selectedDate) : new Date()}
            className="form-control"
            placeholderText="Select Date"
            dateFormat="dd/MM/yyyy"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            disabled={props?.disabled}
            isDisabled={props?.isDisabled}
            readOnly={props?.isDisabled}
            minDate={minDate}
            maxDate={maxDate}
        />
    );
};

export default DatePickercomp;
